import React from 'react';

import PropTypes from 'prop-types';

const GridContainer = ({ children }) => {
  return (
    <div className="hot-container _my-5">
      <div className="hot-row">
        <div className="hot-col-12 _mb-0 _mb-sm-6 _px-0">{children}</div>
      </div>
    </div>
  );
};

GridContainer.propTypes = {
  children: PropTypes.node
};

export default GridContainer;
